const LS = typeof window !== "undefined" ? window.localStorage : null;

export const UI_TTL = 15 * 60 * 1000;
export const HARD_TTL = 24 * 60 * 60 * 1000;

function readEntry(key) {
  if (!LS) return null;
  try {
    const raw = LS.getItem(key);
    if (!raw) return null;
    const obj = JSON.parse(raw);

    if (obj && typeof obj.ts !== "number") {
      if (typeof obj.exp === "number") {
        const approxTs = obj.exp - 120000;
        return { data: obj.data, ts: approxTs > 0 ? approxTs : Date.now() };
      }
      return { data: obj.data, ts: Date.now() };
    }

    return { data: obj.data, ts: obj.ts || 0 };
  } catch {
    return null;
  }
}

export function cacheGetFresh(key, ttlMs = UI_TTL) {
  const e = readEntry(key);
  if (!e) return null;
  if (!e.ts) return e.data;
  return Date.now() - e.ts <= ttlMs ? e.data : null;
}

export function cacheGetStale(key, hardTtlMs = HARD_TTL) {
  const e = readEntry(key);
  if (!e) return null;
  if (!e.ts) return e.data;
  return Date.now() - e.ts <= hardTtlMs ? e.data : null;
}

export function cacheSet(key, data) {
  if (!LS) return;
  try {
    LS.setItem(key, JSON.stringify({ data, ts: Date.now() }));
  } catch {}
}

export function cacheUpdate(key, updater) {
  const cur = readEntry(key)?.data;
  const next = updater(cur);
  cacheSet(key, next);
  return next;
}

export function cacheClear(key) {
  if (!LS) return;
  try { LS.removeItem(key); } catch {}
}

export function cacheGetWithAge(key) {
  const e = readEntry(key);
  if (!e) return null;
  return { data: e.data, ageMs: Date.now() - (e.ts || Date.now()) };
}
